import {Pipe, PipeTransform} from '@angular/core';
import {Product} from "../../products/models/product";

@Pipe({
  name: 'productTitle'
})
export class ProductTitlePipe implements PipeTransform {

  transform(products: Product[], search: string): Product[] {
    if (!search) return products;
    return products.filter(product => product.title.toLowerCase().includes(search));
  }

}
